var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRcght(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "img_rcghrc_56px",
    transform: "translate(-456 -818)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_52",
    "data-name": "\\uD0C0\\uC6D0 52",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(456 818)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_220",
    "data-name": "\\uADF8\\uB8F9 220",
    transform: "translate(466 828)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_466",
    "data-name": "\\uD328\\uC2A4 466",
    d: "M-185.37,572.093a1.213,1.213,0,0,0-1.713.048,1.213,1.213,0,0,0,.048,1.713,12.2,12.2,0,0,1,3.857,8.948,12.324,12.324,0,0,1-12.31,12.31A12.323,12.323,0,0,1-207.8,582.8a12.2,12.2,0,0,1,3.856-8.948,1.211,1.211,0,0,0,.048-1.713,1.213,1.213,0,0,0-1.713-.048,14.6,14.6,0,0,0-4.616,10.71,14.751,14.751,0,0,0,14.734,14.734A14.751,14.751,0,0,0-180.754,582.8,14.6,14.6,0,0,0-185.37,572.093Z",
    transform: "translate(210.222 -567.536)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_467",
    "data-name": "\\uD328\\uC2A4 467",
    d: "M-191.558,580.538a1.212,1.212,0,0,0,1.212-1.212V568.87a1.212,1.212,0,0,0-1.212-1.212,1.212,1.212,0,0,0-1.212,1.212v10.456A1.212,1.212,0,0,0-191.558,580.538Z",
    transform: "translate(210.74 -567.658)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_468",
    "data-name": "\\uD328\\uC2A4 468",
    d: "M-200.177,580.538a1.212,1.212,0,0,0,1.212-1.212V568.87a1.212,1.212,0,0,0-1.212-1.212,1.212,1.212,0,0,0-1.212,1.212v10.456A1.212,1.212,0,0,0-200.177,580.538Z",
    transform: "translate(210.484 -567.658)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "img_ht_25px",
    transform: "translate(26 -547)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_55",
    "data-name": "\\uD0C0\\uC6D0 55",
    transform: "translate(456 1391)",
    fill: "#fff",
    stroke: "#1c1e35",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "img_hrc20",
    transform: "translate(462.876 1393.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_327",
    "data-name": "\\uD328\\uC2A4 327",
    d: "M-994.561,685.429c0-3.589-1.8-6.676-3.163-7.681-.006,0-.1-.057-.1.086,0,0,0,0,0,0-.113,6.931-3.749,8.808-5.75,11.339-4.615,5.839-.322,12.241,4.048,13.424,2.447.662-.565-1.172-.953-5.045C-1000.945,692.877-994.561,689.3-994.561,685.429Z",
    transform: "translate(1005.559 -677.736)",
    fill: "#00023e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_328",
    "data-name": "\\uD328\\uC2A4 328",
    d: "M-878.222,820.249c-.028-.019-.067-.032-.1.013a13.015,13.015,0,0,1-2.152,4.453c-3.936,5.812-1.693,8.615-.431,10.12.732.875,0,0,1.829-.893a8.037,8.037,0,0,0,3.942-6.2A8.881,8.881,0,0,0-878.222,820.249Z",
    transform: "translate(891.342 -810.196)",
    fill: "#06943f"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRcght);
export default __webpack_public_path__ + "static/media/RCGHT.e645a583.svg";
export { ForwardRef as ReactComponent };